import { render, staticRenderFns } from "./VacancyStepWizardSpecial.vue?vue&type=template&id=39f6e0ca&scoped=true&"
import script from "./VacancyStepWizardSpecial.vue?vue&type=script&lang=js&"
export * from "./VacancyStepWizardSpecial.vue?vue&type=script&lang=js&"
import style0 from "./VacancyStepWizardSpecial.vue?vue&type=style&index=0&id=39f6e0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f6e0ca",
  null
  
)

/* custom blocks */
import block0 from "./VacancyStepWizardSpecial.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyStepWizardSpecial.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCol,VRow})
